import { Step } from 'react-joyride';

export const calendarTourSteps: Step[] = [
  {
    target: '[data-tour="calendar-header"]',
    content: (
      <div>
        <h4>Callback Requests</h4>
        <p>
          Manage all customer callback requests in one place. Schedule, accept, decline, and track
          callback appointments with customers.
        </p>
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true
  },
  {
    target: '[data-tour="create-request-button"]',
    content: (
      <div>
        <h4>Create New Request</h4>
        <p>
          Click here to manually create a callback request for a customer. Set the date, time, and
          reason for the callback.
        </p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="filter-status"]',
    content: (
      <div>
        <h4>Filter by Status</h4>
        <p>
          Filter callback requests by their status: pending, accepted, declined, or completed. This
          helps you prioritize your work.
        </p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="search-requests"]',
    content: (
      <div>
        <h4>Search Requests</h4>
        <p>Search for specific callback requests by customer name, phone number, or reason.</p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="requests-table"]',
    content: (
      <div>
        <h4>Requests List</h4>
        <p>
          View all callback requests with customer details, scheduled time, status, and actions.
          Click on any request to view more details or manage it.
        </p>
      </div>
    ),
    placement: 'top'
  },
  {
    target: '[data-tour="request-actions"]',
    content: (
      <div>
        <h4>Request Actions</h4>
        <p>
          Accept, decline, reschedule, or cancel callback requests. You can also edit request
          details or mark them as completed.
        </p>
      </div>
    ),
    placement: 'left'
  }
];
